var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentIncome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 9.40204 9.40202 0 21 0C32.598 0 42 9.40204 42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21Z",
    fill: "#DF9F39"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_96)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 23.25H15.75C15.5511 23.25 15.3603 23.329 15.2197 23.4697C15.079 23.6103 15 23.8011 15 24V27.75C15 27.9489 15.079 28.1397 15.2197 28.2803C15.3603 28.421 15.5511 28.5 15.75 28.5H17.25C17.4489 28.5 17.6397 28.421 17.7803 28.2803C17.921 28.1397 18 27.9489 18 27.75V24C18 23.8011 17.921 23.6103 17.7803 23.4697C17.6397 23.329 17.4489 23.25 17.25 23.25ZM21.75 20.25H20.25C20.0511 20.25 19.8603 20.329 19.7197 20.4697C19.579 20.6103 19.5 20.8011 19.5 21V27.75C19.5 27.9489 19.579 28.1397 19.7197 28.2803C19.8603 28.421 20.0511 28.5 20.25 28.5H21.75C21.9489 28.5 22.1397 28.421 22.2803 28.2803C22.421 28.1397 22.5 27.9489 22.5 27.75V21C22.5 20.8011 22.421 20.6103 22.2803 20.4697C22.1397 20.329 21.9489 20.25 21.75 20.25ZM26.25 17.25H24.75C24.5511 17.25 24.3603 17.329 24.2197 17.4697C24.079 17.6103 24 17.8011 24 18V27.75C24 27.9489 24.079 28.1397 24.2197 28.2803C24.3603 28.421 24.5511 28.5 24.75 28.5H26.25C26.4489 28.5 26.6397 28.421 26.7803 28.2803C26.921 28.1397 27 27.9489 27 27.75V18C27 17.8011 26.921 17.6103 26.7803 17.4697C26.6397 17.329 26.4489 17.25 26.25 17.25ZM16.5 18.75C16.2033 18.75 15.9133 18.838 15.6666 19.0028C15.42 19.1676 15.2277 19.4019 15.1142 19.676C15.0006 19.9501 14.9709 20.2517 15.0288 20.5426C15.0867 20.8336 15.2296 21.1009 15.4393 21.3107C15.6491 21.5204 15.9164 21.6633 16.2074 21.7212C16.4983 21.7791 16.7999 21.7494 17.074 21.6358C17.3481 21.5223 17.5824 21.33 17.7472 21.0834C17.912 20.8367 18 20.5467 18 20.25C18 19.8522 17.842 19.4706 17.5607 19.1893C17.2794 18.908 16.8978 18.75 16.5 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_96"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentIncome);
export default __webpack_public_path__ + "static/media/investment_income.ff8a2a9a88b2fb1e676aaa99334e3582.svg";
export { ForwardRef as ReactComponent };